module.exports = __webpack_public_path__ + "static/reviews-people-5808a4acf952bd4c081b7ded21c3f407.png";